function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_194_5900)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.4372 15.6805H16.5485L16.2335 15.3889C17.5835 13.8769 18.281 11.8141 17.8985 9.62168C17.3697 6.61928 14.7597 4.22168 11.6097 3.85448C6.85098 3.29288 2.84598 7.13768 3.43098 11.7061C3.81348 14.7301 6.31098 17.2357 9.43848 17.7433C11.7222 18.1105 13.871 17.4409 15.446 16.1449L15.7497 16.4473V17.3005L20.531 21.8905C20.9922 22.3333 21.746 22.3333 22.2072 21.8905C22.6685 21.4477 22.6685 20.7241 22.2072 20.2813L17.4372 15.6805ZM10.6872 15.6805C7.88598 15.6805 5.62473 13.5097 5.62473 10.8205C5.62473 8.13128 7.88598 5.96048 10.6872 5.96048C13.4885 5.96048 15.7497 8.13128 15.7497 10.8205C15.7497 13.5097 13.4885 15.6805 10.6872 15.6805Z",
  fill: "#B0B0B0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_194_5900"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 25.92,
  fill: "white",
  transform: "translate(0 0.560547)"
})));

var SvgSearchBlack24Dp = function SvgSearchBlack24Dp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchBlack24Dp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_black_24dp.a6079dab.svg";
export { ForwardRef as ReactComponent };